/**
 * SaraivaCnpjDisponivelCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {SaraivaCnpjDisponivel} from '@/model/resource/SaraivaCnpjDisponivel'

/* TODO: review generated class */
@HttpExclude()
export class SaraivaCnpjDisponivelCollection extends PageCollection<
  SaraivaCnpjDisponivel
> {
  constructor() {
    super(SaraivaCnpjDisponivel)
  }

  queryAsPage() {
    return this.listSaraivaCnpjDisponivel()
  }

  async listSaraivaCnpjDisponivel() {
    return await Request.get(`/admin/saraiva-cnpj-disponivel`, {
      params: this.params,
    })
      .name('listSaraivaCnpjDisponivel')
      .as(this)
      .getResponse()
  }

  async listCsvSaraivaCnpjDisponivel() {
    return await Request.get(`/admin/saraiva-cnpj-disponivel/csv`, {
      params: this.params,
    })
      .name('listCsvSaraivaCnpjDisponivel')
      .as(this)
      .getResponse()
  }
}
